import { Model } from '@vuex-orm/core';

export default class Kampagnen extends Model {
  static entity = 'kampagnen';
  static primaryKey = 'id';
  /**
   * @param {import('@vuex-orm/core').Record} record
   */
  constructor(record) {
    super(record);
    /** @type {string} */
    this.id;
    /** @type {number | null} */
    this.reihenfolge;
    /** @type {string | null} */
    this.seitenhintergrund;
    /** @type {string | null} */
    this.header;
    /** @type {string | null} */
    this.headersub;
    /** @type {string | null} */
    this.textdetail;
    /** @type {any} */
    this.objekte;
    /** @type {string | null} */
    this.objekticon;
    /** @type {boolean | null} */
    this.modul0anzeige;
    /** @type {string | null} */
    this.modul0textposition;
    /** @type {number | null} */
    this.modul0bildbreite;
    /** @type {string | null} */
    this.modul1typ;
    /** @type {string | null} */
    this.modul1text;
    /** @type {string | null} */
    this.modul1bild;
    /** @type {number | null} */
    this.modul1bildbreite;
    /** @type {boolean | null} */
    this.modul1anzeige;
    /** @type {string | null} */
    this.modul2typ;
    /** @type {string | null} */
    this.modul2text;
    /** @type {string | null} */
    this.modul2bild;
    /** @type {number | null} */
    this.modul2bildbreite;
    /** @type {boolean | null} */
    this.modul2anzeige;
    /** @type {string | null} */
    this.modul3typ;
    /** @type {string | null} */
    this.modul3text;
    /** @type {string | null} */
    this.modul3bild;
    /** @type {number | null} */
    this.modul3bildbreite;
    /** @type {boolean | null} */
    this.modul3anzeige;
    /** @type {string | null} */
    this.modul4typ;
    /** @type {string | null} */
    this.modul4text;
    /** @type {string | null} */
    this.modul4bild;
    /** @type {number | null} */
    this.modul4bildbreite;
    /** @type {boolean | null} */
    this.modul4anzeige;
    /** @type {string | null} */
    this.modul5typ;
    /** @type {string | null} */
    this.modul5text;
    /** @type {string | null} */
    this.modul5bild;
    /** @type {number | null} */
    this.modul5bildbreite;
    /** @type {boolean | null} */
    this.modul5anzeige;
    /** @type {string | null} */
    this.modul6typ;
    /** @type {string | null} */
    this.modul6text;
    /** @type {string | null} */
    this.modul6bild;
    /** @type {number | null} */
    this.modul6bildbreite;
    /** @type {boolean | null} */
    this.modul6anzeige;
    /** @type {any} */
    this.modulsort;
    /** @type {string | null} */
    this.veranstaltungentext;
    /** @type {boolean | null} */
    this.veranstaltungenanzeige;
    /** @type {string | null} */
    this.newstext;
    /** @type {boolean | null} */
    this.newsanzeige;
    /** @type {string | null} */
    this.downloadstext;
    /** @type {boolean | null} */
    this.downloadsanzeige;
    /** @type {any} */
    this.poolbilder;
    /** @type {any} */
    this.poolpdf;
    /** @type {boolean | null} */
    this.aktiv;
    /** @type {boolean | null} */
    this.titelseite;
    /** @type {string} */
    this.modulwissen;
    /** @type {string} */
    this.modultitel;
    /** @type {string | null} */
    this.routerurl;
    /** @type {string | null} */
    this.metatitle;
    /** @type {string | null} */
    this.metadescription;
    /** @type {string | null} */
    this.updatedAt;
    /** @type {string | null} */
    this.createdAt;
  }

  static fields() {
    return {
      id: this.string(''),
      reihenfolge: this.number(0).nullable(),
      seitenhintergrund: this.string('').nullable(),
      header: this.string('').nullable(),
      headersub: this.string('').nullable(),
      textdetail: this.string('').nullable(),
      objekte: this.attr([]).nullable(),
      objekticon: this.string('').nullable(),
      modul0anzeige: this.boolean(false).nullable(),
      modul0textposition: this.string('rechts').nullable(),
      modul0bildbreite: this.number(2).nullable(),
      modul1typ: this.string('').nullable(),
      modul1text: this.string('').nullable(),
      modul1bild: this.string('').nullable(),
      modul1bildbreite: this.number(2).nullable(),
      modul1anzeige: this.boolean(false).nullable(),
      modul2typ: this.string('').nullable(),
      modul2text: this.string('').nullable(),
      modul2bild: this.string('').nullable(),
      modul2bildbreite: this.number(2).nullable(),
      modul2anzeige: this.boolean(false).nullable(),
      modul3typ: this.string('').nullable(),
      modul3text: this.string('').nullable(),
      modul3bild: this.string('').nullable(),
      modul3bildbreite: this.number(2).nullable(),
      modul3anzeige: this.boolean(false).nullable(),
      modul4typ: this.string('').nullable(),
      modul4text: this.string('').nullable(),
      modul4bild: this.string('').nullable(),
      modul4bildbreite: this.number(2).nullable(),
      modul4anzeige: this.boolean(false).nullable(),
      modul5typ: this.string('').nullable(),
      modul5text: this.string('').nullable(),
      modul5bild: this.string('').nullable(),
      modul5bildbreite: this.number(2).nullable(),
      modul5anzeige: this.boolean(false).nullable(),
      modul6typ: this.string('').nullable(),
      modul6text: this.string('').nullable(),
      modul6bild: this.string('').nullable(),
      modul6bildbreite: this.number(2).nullable(),
      modul6anzeige: this.boolean(false).nullable(),
      modulsort: this.attr(['K', '1', '2', '3', '4', '5', 'V', 'N', 'D', '6']).nullable(),
      veranstaltungentext: this.string('').nullable(),
      veranstaltungenanzeige: this.boolean(false).nullable(),
      newstext: this.string('').nullable(),
      newsanzeige: this.boolean(false).nullable(),
      downloadstext: this.string('').nullable(),
      downloadsanzeige: this.boolean(false).nullable(),
      poolbilder: this.attr([]).nullable(),
      poolpdf: this.attr([]).nullable(),
      aktiv: this.boolean(false).nullable(),
      titelseite: this.boolean(false).nullable(),
      modulwissen: this.string('1'),
      modultitel: this.string('1'),
      routerurl: this.string('').nullable(),
      metatitle: this.string('').nullable(),
      metadescription: this.string('').nullable(),
      updatedAt: this.string('').nullable(),
      createdAt: this.string('').nullable()
    };
  }
}
